module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_7005.0759b0f3.png";